export const PrimaryFont = "Kulim Park, sans-serif";
export const SecondaryFont = "Monda, sans-serif";
// export const PrimaryFont = "Tahoma, sans-serif";
export const typeScale = {
  header1: "4.209rem",
  header2: "3.157rem",
  header3: "2.369rem",
  header4: "1.777rem",
  header5: "1.333rem",
  paragraph: "1rem",
  helperText: "0.8rem",
  copyrightText: "0.7rem",
};
